import { useLocalStorage, useOrgId } from '@spotify/confidence-core-react';
import { useFeatureFlag } from '@spotify/confidence-flag-evaluation-react';
import { useCheckResourcePermissions } from '@spotify/plugin-confidence-permissions-react';

// TODO: move to a backend-persisted account setting when enabling for more customers
const STORAGE_KEY_PREFIX = 'confidence:advancedWarehouseMode:v1';

export const useIsMultiWarehouseEnabled = (): boolean =>
  useFeatureFlag('multi-wh-frontend.enabled', false);

export const useAdvancedWarehouseMode = (): readonly [
  boolean,
  (value: boolean) => void,
] => {
  const isMultiWarehouseEnabled = useIsMultiWarehouseEnabled();
  const { allowed: canEditWarehouse } = useCheckResourcePermissions({
    name: 'account',
    can: 'edit_data_warehouse',
  });
  const [orgId] = useOrgId();
  const storageKey = `${STORAGE_KEY_PREFIX}:${orgId}`;
  const [isStored, setStored] = useLocalStorage<boolean>(storageKey, false, {
    migrateKey: false,
  });

  const isEnabled = isMultiWarehouseEnabled && canEditWarehouse && isStored;

  return [isEnabled, setStored] as const;
};
